import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';

// Можно ли показывать кнопку "Открыть" на тамбе для паблик файлов. По дефолту можно в онпремис
export const showPublicFileOpenButton = isFeature('public-file-open-btn') || IS_ONPREMISE;
